export function generateWinLossRecord(wrestler) {
  if (wrestler?.wins > 0) {
    return { wins: wrestler.wins, losses: wrestler.losses };
  }
  const BASE = 300; // Increased base to 300
  const performance = (2 * (wrestler?.points || 70)) - (0.5 * (wrestler?.damage || 30)) + (0.5 * (wrestler?.stamina || 30));

  const winRatio = performance / BASE;
  const totalMatches = 40;
  const wins = Math.round(winRatio * totalMatches);
  const losses = ((totalMatches - wins) > 0) ? totalMatches - wins : 0;

  return {
    wins,
    losses
  }
}

export const migrations = [
  {
    title: '10 to 10.2',
    description: 'Post release updates',
    groupNames: ["GAME"],
    sortOrder: 0,
    transform: (session) => {
      session.Game.all()
        .toModelArray()
        .forEach(item => {
          item.storeVersion = 300

          item.update()
        })

      return session
    }
  },
  {
    title: '10.2 to 10.35',
    description: 'Post release updates',
    groupNames: ["GAME"],
    sortOrder: 0,
    transform: (session) => {
      session.Game.all()
        .toModelArray()
        .forEach(item => {
          item.storeVersion = 1035
          item.setupComplete = true
          item.setupEmpty = true

          item.update()
        })

      return session
    }
  },
  {
    title: '10.35 to 10.5',
    description: 'Add nickname field to Wrestler',
    groupNames: ["GAME"],
    sortOrder: 0,
    transform: (session) => {
      session.Game.all()
        .toModelArray()
        .forEach(item => {
          item.storeVersion = 1050

          item.update()
        })
      session.Wrestler.all()
        .toModelArray()
        .forEach(item => {
          item.nickname = '';

          item.update()
        })
      session.Segment.all()
        .toModelArray()
        .forEach(item => {
          item.rating = 0;

          item.update()
        })

      return session
    }
  },
]
function pickRandomIdsFromArray(array) {
  const randomItems = []
  const randomLength = Math.floor(Math.random() * array.length)
  for (let i = 0; i < randomLength; i++) {
    const randomIndex = Math.floor(Math.random() * array.length)
    if (!randomItems.includes(array[randomIndex])) {
      randomItems.push(array[randomIndex])
    }
  }
  return randomItems
}

export const modifiers = [
  {
    title: 'Generate random win/loss record based on points',
    description: 'Generate random win/loss record based on points',
    groupNames: ["GAME", "WRESTLER"],
    sortOrder: 0,
    transform: (session) => {
      session.Wrestler.all().toModelArray().forEach(item => {
        const { wins, losses } = generateWinLossRecord(item)

        item.wins = Number(wins)
        item.losses = Number(losses)
        item.streak = 0

        item.update()
      })
    }
  },
  {
    title: 'Randomise everyones brands',
    description: 'Randomise everyones brands',
    groupNames: ["GAME", "WRESTLER"],
    sortOrder: 0,
    transform: (session) => {
      session.Wrestler.all()
        .toModelArray()
        .forEach(item => {
          item.brandIds = pickRandomIdsFromArray(session?.Brand?.all()?.toRefArray()?.map(item => item.id))

          item.update()
        })
    }
  },
  {
    title: 'Half everyones costs',
    description: 'Half everyones costs',
    groupNames: ["GAME", "WRESTLER"],
    sortOrder: 0,
    transform: (session) => {
      session.Wrestler.all()
        .toModelArray()
        .forEach(item => {
          item.cost = Math.floor(item.cost / 2)

          item.update()
        })
    }
  },
  {
    title: 'Reset Birthdays',
    description: 'Reset all Wrestler date of births',
    groupNames: ["GAME", "WRESTLER"],
    sortOrder: 0,
    transform: (session) => {
      session.Wrestler.all()
        .toModelArray()
        .forEach(item => {
          item.dob = null

          item.update()
        })

      return session
    }
  },
  {
    title: 'Reset Win/Loss',
    description: 'Reset all Wrestler wins/losses/streaks',
    groupNames: ["GAME", "WRESTLER"],
    sortOrder: 0,
    transform: (session) => {
      session.Wrestler.all()
        .toModelArray()
        .forEach(item => {
          item.wins = 0
          item.losses = 0
          item.streaks = 0

          item.update()
        })

      return session
    }
  },
  {
    title: 'Reset Injuries',
    description: 'Reset all damage and set all active',
    groupNames: ["GAME", "WRESTLER"],
    sortOrder: 0,
    transform: (session) => {
      session.Wrestler.all()
        .toModelArray()
        .forEach(item => {
          item.active = true
          item.damage = 0

          item.update()
        })

      return session
    }
  }
]
